export default {"src":"https://images-cdn.curipod.com/d-0efe569d/_next/static/media/feide-logo.aab537d8.ico","height":48,"width":48};